module.exports = __webpack_public_path__ + "static/media/blaze.3c684b6e.jpg";